import { Pipe, PipeTransform } from '@angular/core';
import { UserWorkplaceHoursObject } from '@libs/types/src/user/object-type/workplace/user-workplace-hours.object';
import { toMilitaryTime } from '../../../../../utils/date.utils';
import { WorkplaceHoursFrequencyEnum } from '@libs/types/src/services/enum/workplace-hours-frequency.enum';

@Pipe({
    name: 'userWorkplaceHoursParser',
    pure: true,
})

export class UserWorkplaceHoursParserPipes implements PipeTransform {

    public transform(value: any, ...args: any[]): any {
        const parsed: Record<number, any[]> = {
            1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [],
        };

        value.forEach((it: any) => {
            let day = it.value.day;
            if (day == 0) day = 7;
            parsed[day].push(it);
        });

        return parsed;
    }

}

@Pipe({
    name: 'userWorkplaceIsOpen'
    ,
    pure:
        true,
})

export class UserWorkplaceIsOpenPipe implements PipeTransform {

    public transform(_value: UserWorkplaceHoursObject[], validFrom: string | null, ...args: any[]): any {
        const from = new Date(validFrom || 'now');
        const now = new Date();
        const day = now.getDay();
        const mNow = toMilitaryTime(now);

        const currWeekInMonth = this.getWeekOfMonth(now);
        const weekPassed = this.weeksPassed(from);
        const monthsPassed = this.monthsPassed(from);

        const value = _value
            .filter((it) => it.day == day)
            .filter((it) => {
                let dFrom = '0000';
                let dTo = '2400';

                if (it.from) {
                    dFrom = toMilitaryTime(it.from);
                }
                if (it.to) {
                    dTo = toMilitaryTime(it.to);
                }

                return mNow > dFrom && mNow < dTo;
            })
            .filter((it) => {
                switch (it.type) {
                    case WorkplaceHoursFrequencyEnum.EVERY_1_WEEK:
                        return true;
                    case WorkplaceHoursFrequencyEnum.EVERY_2_WEEK:
                        return (weekPassed % 2) === 0;
                    case WorkplaceHoursFrequencyEnum.EVERY_3_WEEK:
                        return (weekPassed % 3) === 0;
                    case WorkplaceHoursFrequencyEnum.EVERY_4_WEEK:
                        return (weekPassed % 4) === 0;
                    case WorkplaceHoursFrequencyEnum.EVERY_1st_WEEK_IN_MONTH:
                        return currWeekInMonth === 1;
                    case WorkplaceHoursFrequencyEnum.EVERY_2nd_WEEK_IN_MONTH:
                        return currWeekInMonth === 2;
                    case WorkplaceHoursFrequencyEnum.EVERY_3rd_WEEK_IN_MONTH:
                        return currWeekInMonth === 3;
                    case WorkplaceHoursFrequencyEnum.EVERY_4th_WEEK_IN_MONTH:
                        return currWeekInMonth === 4;
                    case WorkplaceHoursFrequencyEnum.EVERY_1st_WEEK_IN_EVERY_2nd_MONTH:
                        return currWeekInMonth === 1 && ((monthsPassed % 2) == 0);
                    case WorkplaceHoursFrequencyEnum.EVERY_2nd_WEEK_IN_EVERY_2nd_MONTH:
                        return currWeekInMonth === 2 && ((monthsPassed % 2) == 0);
                    case WorkplaceHoursFrequencyEnum.EVERY_3rd_WEEK_IN_EVERY_2nd_MONTH:
                        return currWeekInMonth === 3 && ((monthsPassed % 2) == 0);
                    case WorkplaceHoursFrequencyEnum.EVERY_4th_WEEK_IN_EVERY_2nd_MONTH:
                        return currWeekInMonth === 4 && ((monthsPassed % 2) == 0);
                    default:
                        return false;
                }
            })
        ;

        return value.length > 0;
    }

    private getWeekOfMonth(date: Date) {
        const month = new Date(date);
        month.setDate(1);
        const firstDay = month.getDay();
        const weekSince = (8 - firstDay) % 7;

        return Math.ceil((date.getDate() - weekSince) / 7);
    }

    private weeksPassed(_date: Date) {
        const date = new Date(_date);
        date.setDate(date.getDate() - date.getDay());
        const now = new Date();
        const passed = now.getTime() - date.getTime();

        return Math.floor(passed / 1_000 / 60 / 60 / 24 / 7);
    }

    private monthsPassed(date: Date) {
        const now = new Date();
        return (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());
    }

}
